export const translations = {
  es: {
    hero: {
      badge: 'Tu Proveedor #1 en New York — CT',
      title1: '¿Cansado de Perder Tiempo y Dinero ',
      title2: 'Buscando Productos',
      title3: ' para tu Barbería?',
      subtitle1:
        'JP Barber Mobile Supply Te Los Lleva Directo a Tu Puerta — Mismo Día.',
      subtitle2:
        'El único proveedor móvil de barbería en New York y City of Waterbury, CT que te ahorra tiempo, dinero y viajes innecesarios. Sin mínimo de orden. Sin complicaciones.',
      cta: 'Ordena Ahora',
    },
    problem: {
      title: 'Sabemos lo que sientes.',
      time: 'Son las 8:00 AM. Tu barbería abre en una hora.',
      desc1:
        'Te quedaste sin neck strips. Sin shaving gel. Sin el producto que más vendes.',
      desc2: 'Tienes dos opciones:',
      opt1Title: 'Cerrar temprano',
      opt1Desc:
        'Y perder clientes, dinero y la confianza de tu clientela habitual.',
      opt2Title: 'Manejar 40 minutos',
      opt2Desc:
        'Al supply más cercano, gastar gasolina, pagar parqueo y llegar estresado.',
      conclusion1: 'Ninguna de las dos es buena.',
      conclusion2: 'Eso tiene que cambiar.',
    },
    solution: {
      title1: 'JP Barber Mobile Supply ',
      title2: 'llegó para resolver eso.',
      subtitle:
        'Somos un proveedor móvil de suministros para barberías en New York.',
      benefits: [
        'Te llevamos los productos donde estés',
        'Mismo día de entrega',
        'Precios de mayorista',
        'Sin mínimo de orden',
        'Servicio personalizado',
        'Disponible 7 días a la semana',
      ],
    },
    catalog: {
      badge: 'Catálogo',
      title1: 'Nuestros ',
      title2: 'Productos',
      subtitle:
        'Desliza para ver todos los productos. Fotos reales, precios de mayorista.',
      orderBtn: 'Pedir',
      bottomText:
        '¿No ves lo que buscas? Tenemos más de 50 productos disponibles.',
      bottomBtn: 'Ver Catálogo Completo',
    },
    products: {
      title: 'Productos Disponibles',
      subtitle: 'Todo lo que necesitas. En un solo lugar.',
    },
    whyUs: {
      title: 'Por Qué Elegirnos',
      subtitle1: 'JP Barber Mobile Supply no es solo otro proveedor.',
      subtitle2: 'Somos tu socio de negocio.',
      subtitle3:
        '5 razones por las que los barberos de New York nos prefieren:',
      reasons: [
        {
          title: 'ENTREGA MISMO DÍA',
          desc: 'No esperas. Nosotros llegamos a ti.',
        },
        { title: 'PRECIOS DE MAYORISTA', desc: 'Pagas menos. Ganas más.' },
        {
          title: 'SIN MÍNIMO DE ORDEN',
          desc: 'Pide lo que necesitas. Nada más.',
        },
        {
          title: 'SERVICIO PERSONALIZADO',
          desc: 'Conocemos tu negocio y tus productos.',
        },
        {
          title: 'DISPONIBLE 7 DÍAS',
          desc: 'Lunes a domingo. Siempre disponible.',
        },
      ],
    },
    testimonials: {
      title: 'Lo Que Dicen Los Barberos',
      items: [
        {
          quote:
            'JP Barber me salvó un sábado cuando me quedé sin productos a las 9AM. En 2 horas ya tenía todo.',
          name: 'Carlos M.',
          role: 'Barbero',
          location: 'The Bronx',
        },
        {
          quote:
            'Los precios son iguales o mejores que ir al supply. Y me los traen aquí.',
          name: 'Miguel R.',
          role: 'Dueño de Barbería',
          location: 'Brooklyn',
        },
        {
          quote:
            'Ya no pierdo tiempo manejando. JP Barber es lo mejor que me pasó como dueño de negocio.',
          name: 'Luis A.',
          role: 'Barbero',
          location: 'Manhattan',
        },
      ],
    },
    specialOffer: {
      badge: 'OFERTA DE BIENVENIDA',
      title: 'Primera orden con JP Barber Mobile Supply',
      benefits: [
        'Envío GRATIS en tu primera orden',
        '10% de descuento en productos seleccionados',
        'Catálogo completo de precios GRATIS',
      ],
      note: 'Esta oferta es solo para nuevos clientes. Limitado a los primeros 20 barberos del mes.',
    },
    guarantee: {
      title: 'GARANTÍA TOTAL JP BARBER',
      p1: 'Si el producto llega dañado, te lo reemplazamos sin preguntas.',
      p2: 'Si no quedas satisfecho, te devolvemos tu dinero.',
      p3: 'Así de simple. Así de serio.',
    },
    ctaSection: {
      title: '¿Listo para simplificar tu negocio?',
      subtitle: 'Respondemos en menos de 30 minutos. Entregamos el mismo día.',
      btn1: 'WhatsApp',
      btn2: 'Llamar Ahora',
      footer: 'Tu proveedor. Tu socio. Tu solución.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [
        {
          q: '¿Hacen entregas el mismo día?',
          a: 'Sí, en la mayoría de las zonas de NY.',
        },
        {
          q: '¿Tienen mínimo de orden?',
          a: 'No, puedes pedir desde 1 producto.',
        },
        {
          q: '¿Cuáles son sus áreas de servicio?',
          a: 'Bronx, Brooklyn, Manhattan, Queens.',
        },
        {
          q: '¿Aceptan pagos en efectivo?',
          a: 'Sí, también Zelle, CashApp y Venmo.',
        },
        {
          q: '¿Tienen catálogo de precios?',
          a: 'Sí, te lo enviamos por WhatsApp gratis.',
        },
        {
          q: '¿Manejan productos al por mayor?',
          a: 'Sí, tenemos precios especiales por volumen.',
        },
      ],
    },
    footer: {
      desc: 'Tu proveedor #1 de suministros para barberías en New York. Entregas el mismo día, sin mínimo de orden.',
      areasTitle: 'Áreas de Servicio',
      contactTitle: 'Contacto & Horario',
      hoursTitle: 'Horario de Atención:',
      hours: 'Lunes a Domingo',
      rights: 'Todos los derechos reservados.',
    },
  },
  en: {
    hero: {
      badge: 'Your #1 Supplier in New York — CT',
      title1: 'Tired of Wasting Time and Money ',
      title2: 'Looking for Products',
      title3: ' for your Barbershop?',
      subtitle1:
        'JP Barber Mobile Supply Delivers Direct to Your Door — Same Day.',
      subtitle2:
        'The only mobile barber supplier in New York and City of Waterbury, CT that saves you time, money, and unnecessary trips. No minimum order. No hassle.',
      cta: 'Order Now',
    },
    problem: {
      title: 'We know how it feels.',
      time: "It's 8:00 AM. Your barbershop opens in an hour.",
      desc1:
        'You ran out of neck strips. Out of shaving gel. Out of your best-selling product.',
      desc2: 'You have two options:',
      opt1Title: 'Close early',
      opt1Desc:
        'And lose clients, money, and the trust of your regular customers.',
      opt2Title: 'Drive 40 minutes',
      opt2Desc:
        'To the nearest supply, waste gas, pay for parking, and arrive stressed.',
      conclusion1: 'Neither option is good.',
      conclusion2: 'That has to change.',
    },
    solution: {
      title1: 'JP Barber Mobile Supply ',
      title2: 'is here to solve that.',
      subtitle: 'We are a mobile barber supply provider in New York.',
      benefits: [
        'We bring the products to wherever you are',
        'Same-day delivery',
        'Wholesale prices',
        'No minimum order',
        'Personalized service',
        'Available 7 days a week',
      ],
    },
    catalog: {
      badge: 'Catalog',
      title1: 'Our ',
      title2: 'Products',
      subtitle: 'Swipe to see all products. Real photos, wholesale prices.',
      orderBtn: 'Order',
      bottomText:
        "Don't see what you're looking for? We have over 50 products available.",
      bottomBtn: 'View Full Catalog',
    },
    products: {
      title: 'Available Products',
      subtitle: 'Everything you need. In one place.',
    },
    whyUs: {
      title: 'Why Choose Us',
      subtitle1: 'JP Barber Mobile Supply is not just another supplier.',
      subtitle2: 'We are your business partner.',
      subtitle3: '5 reasons why New York barbers prefer us:',
      reasons: [
        { title: 'SAME DAY DELIVERY', desc: "You don't wait. We come to you." },
        { title: 'WHOLESALE PRICES', desc: 'Pay less. Earn more.' },
        {
          title: 'NO MINIMUM ORDER',
          desc: 'Order what you need. Nothing more.',
        },
        {
          title: 'PERSONALIZED SERVICE',
          desc: 'We know your business and your products.',
        },
        {
          title: 'AVAILABLE 7 DAYS',
          desc: 'Monday to Sunday. Always available.',
        },
      ],
    },
    testimonials: {
      title: 'What Barbers Are Saying',
      items: [
        {
          quote:
            'JP Barber saved me on a Saturday when I ran out of products at 9AM. In 2 hours I had everything.',
          name: 'Carlos M.',
          role: 'Barber',
          location: 'The Bronx',
        },
        {
          quote:
            'Prices are equal or better than going to the supply. And they bring them right here.',
          name: 'Miguel R.',
          role: 'Barbershop Owner',
          location: 'Brooklyn',
        },
        {
          quote:
            'I no longer waste time driving. JP Barber is the best thing that happened to me as a business owner.',
          name: 'Luis A.',
          role: 'Barber',
          location: 'Manhattan',
        },
      ],
    },
    specialOffer: {
      badge: 'WELCOME OFFER',
      title: 'First order with JP Barber Mobile Supply',
      benefits: [
        'FREE shipping on your first order',
        '10% discount on selected products',
        'Full price catalog for FREE',
      ],
      note: 'This offer is for new customers only. Limited to the first 20 barbers of the month.',
    },
    guarantee: {
      title: 'JP BARBER TOTAL GUARANTEE',
      p1: 'If the product arrives damaged, we replace it no questions asked.',
      p2: "If you're not satisfied, we refund your money.",
      p3: 'That simple. That serious.',
    },
    ctaSection: {
      title: 'Ready to simplify your business?',
      subtitle: 'We respond in under 30 minutes. We deliver the same day.',
      btn1: 'WhatsApp',
      btn2: 'Call Now',
      footer: 'Your supplier. Your partner. Your solution.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        { q: 'Do you do same-day deliveries?', a: 'Yes, in most areas of NY.' },
        {
          q: 'Is there a minimum order?',
          a: 'No, you can order from just 1 product.',
        },
        {
          q: 'What are your service areas?',
          a: 'Bronx, Brooklyn, Manhattan, Queens.',
        },
        {
          q: 'Do you accept cash payments?',
          a: 'Yes, also Zelle, CashApp, and Venmo.',
        },
        {
          q: 'Do you have a price catalog?',
          a: 'Yes, we send it via WhatsApp for free.',
        },
        {
          q: 'Do you handle wholesale products?',
          a: 'Yes, we have special volume pricing.',
        },
      ],
    },
    footer: {
      desc: 'Your #1 barber supply provider in New York. Same-day delivery, no minimum order.',
      areasTitle: 'Service Areas',
      contactTitle: 'Contact & Hours',
      hoursTitle: 'Business Hours:',
      hours: 'Monday to Sunday',
      rights: 'All rights reserved.',
    },
  },
}
